import { Select, styled, TextField } from '@mui/material'

export const SmallWhiteInput = styled(TextField)(() => ({
    '& .MuiInputBase-input': {
      backgroundColor: '#fff',
      borderRadius: 23,
      padding: '10px 18px',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    }
}))

export const SmallGrayInput = styled(TextField)(() => ({
  '& .MuiInputBase-input': {
    backgroundColor: '#F2F3F4',
    borderRadius: 23,
    padding: '10px 18px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}))

export const CustomCheckinInput = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#F2F3F4',
    borderRadius: '8px',
    fontSize: '14px',
  },
  '& .MuiInputBase-input': {
    padding: '14px 16px'
  },
  '& textarea': {
    padding: '0!important'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .Mui-disabled': {
    filter: 'contrast(0.95)',
  },
  '& input::placeholder': {
    fontWeight: 400,
    color: '#808DA0'
  },
  '& input::-moz-input-placeholder': {
    fontWeight: 400,
    color: '#808DA0'
  },
  '& input::-webkit-input-placeholder ': {
    fontWeight: 400,
    color: '#808DA0'
  },
  '& input::-ms-input-placeholder': {
    fontWeight: 400,
    color: '#808DA0'
  }
}))

export const CenteredCheckinInput = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#F2F3F4',
    borderRadius: '8px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .Mui-disabled': {
    filter: 'contrast(0.9)',
  },
  '& .MuiInputBase-input': {
    textAlign: 'center',
  },
}))

export const CustomSelect = styled(Select)(() => ({
  '& .MuiSelect-select': {
    background: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    padding: '14px 16px'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiPaper-elevation': {
    marginTop: '15px'
  },
  '& .Mui-disabled': {
    filter: 'contrast(0.9)',
  },
}))

export const CustomAdminSelect = styled(Select)(() => ({
  '& .MuiSelect-select': {
    background: '#FFF',
    borderRadius: '23px !important',
    padding: '10px 18px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiPaper-elevation': {
    marginTop: '15px'
  },
  '& .Mui-disabled': {
    filter: 'contrast(0.9)',
  },
}))
